import React, { useState } from "react";
import { Reveal } from "../components/Reveal";
import { X } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import SEO, { organizationSchema } from "../components/SEO";

const images = Array.from({ length: 22 }, (_, i) => `/images/gallery/lsp-${i + 1}.jpg`);
const heights = ["h-64", "h-80", "h-96", "h-72", "h-[22rem]", "h-64", "h-80", "h-72"];

export default function Gallery() {
  const { t } = useLang();
  const [open, setOpen] = useState(null);

  return (
    <div>
      <SEO metaKey="gallery" pathname="/gallery" schemas={[organizationSchema()]} />

      <section className="relative isolate bg-forest text-white">
        <div className="absolute inset-0 z-0">
          <img src="/images/gallery/lsp-17.jpg" alt="" className="w-full h-full object-cover" loading="eager" />
          <div className="absolute inset-0 bg-black/55 md:bg-forest/75" />
        </div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-28 lg:py-40 min-h-[60vh] flex flex-col justify-end">
          <Reveal>
            <div className="editorial-divider mb-6 max-w-xs" style={{ color: "#E3A839" }}>{t("gallery_page.eyebrow")}</div>
            <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-8xl leading-[0.96] max-w-5xl">
              {t("gallery_page.h1a")} <br /> <span className="italic text-mustard">{t("gallery_page.h1b")}</span>
            </h1>
            <p className="mt-8 max-w-2xl text-lg text-white/85 leading-relaxed">{t("gallery_page.intro")}</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ivory">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-16 lg:py-24 columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-5 space-y-5">
          {images.map((src, i) => (
            <button key={src} data-testid={`gallery-item-${i+1}`} onClick={() => setOpen(src)}
              className="block w-full overflow-hidden rounded-xl bg-kraft/40 group relative break-inside-avoid">
              <img src={src} alt={`LSP farm photo ${i+1}`} className={`w-full ${heights[i % heights.length]} object-cover group-hover:scale-105 transition-transform duration-700`} loading="lazy" />
              <div className="absolute inset-0 bg-forest/0 group-hover:bg-forest/20 transition-colors duration-500" />
            </button>
          ))}
        </div>
      </section>

      {open && (
        <div data-testid="gallery-lightbox" className="fixed inset-0 z-[80] bg-forest/95 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <button data-testid="gallery-lightbox-close" className="absolute top-6 right-6 text-ivory" onClick={() => setOpen(null)}>
            <X className="w-8 h-8" />
          </button>
          <img src={open} alt="" className="max-h-[92vh] max-w-[92vw] rounded-xl object-contain" />
        </div>
      )}
    </div>
  );
}
